module.exports = __webpack_public_path__ + "img/securdia_pdf_logo.9a10b3ba.png";